import { record } from './data/model.js';

export const SAFE_ROUTE = Object.freeze({ view: 'overview' });
const SIMPLE_VIEWS = new Set(['overview', 'customers', 'commercial', 'material', 'invoices', 'workcard', 'about']);

export function parseRoute(search) {
  const params = new URLSearchParams(search);
  const view = params.get('view') || 'overview';
  if (SIMPLE_VIEWS.has(view)) return { view };
  if (view === 'record') {
    const type = params.get('type');
    const id = params.get('id');
    return record(type, id) ? { view, type, id } : { ...SAFE_ROUTE };
  }
  if (view === 'workflow') {
    const story = params.get('story') || 'kita';
    if (!['kita', 'stock', 'elb'].includes(story)) return { ...SAFE_ROUTE };
    if (story !== 'kita') return { view, story };
    const rawStep = params.get('step') || '1';
    if (!/^[1-5]$/.test(rawStep)) return { ...SAFE_ROUTE };
    const requestedStep = Number(rawStep);
    const acceptance = params.get('acceptance') === 'recorded' ? 'recorded' : null;
    const step = requestedStep >= 4 && !acceptance ? 3 : requestedStep;
    return { view, story, step, acceptance };
  }
  return { ...SAFE_ROUTE };
}

export function href(route) {
  const params = new URLSearchParams();
  Object.entries(route).forEach(([key, value]) => value !== null && value !== undefined && params.set(key, String(value)));
  return `?${params.toString()}`;
}

export function navigate(route, { replace = false } = {}) {
  const url = href(route);
  history[replace ? 'replaceState' : 'pushState']({}, '', url);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

